// extracted by mini-css-extract-plugin
module.exports = {"image":"eX3V4","wrapper":"_2uKgQ","body":"_1wDoA","wrapperForm":"_2ogJE"};